module.exports = __webpack_public_path__ + "ad786fbe8b3f49ba47abe70f2b1c379c.png";